import { render, staticRenderFns } from "./ExportTemplateForArea.vue?vue&type=template&id=60a2a28d&scoped=true"
import script from "./ExportTemplateForArea.vue?vue&type=script&lang=js"
export * from "./ExportTemplateForArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2a28d",
  null
  
)

export default component.exports